import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn, Validators } from '@angular/forms';

/** Birth date must be at least 6 years old */
export function minAgeDobValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {

        var isInvalidMinDobDate = false;
        var dob = control.value;
        if (dob != null) {
            var timestamp = Date.parse(dob);

            if (!isNaN(timestamp)) {

                var date = new Date(dob);

              //if (calculateAge(date) == 6) {
                //isInvalidMinDobDate = false;
                //console.log('in directive 19 calculateAge(date)' + calculateAge(date));
                //console.log('in directive 20 isInvalidMinDobDate' + isInvalidMinDobDate);
              //}
              //else if (calculateAge(date) < 7) {
              if (calculateAge(date) < 7) {
                isInvalidMinDobDate = true;
                //console.log('in directive 25 calculateAge(date)' + calculateAge(date));
                //console.log('in directive 26 isInvalidMinDobDate' + isInvalidMinDobDate);

              }
              

              
              

             
               
              

            }
        }





        return isInvalidMinDobDate  ? { 'minAgeDob': { value: control.value } } : null;
    };
}


export function calculateAge(birthday: Date) { // birthday is a date
    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}


@Directive({
    selector: '[minAgeDob]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MinAgeDobValidatorDirective, multi: true }]
})
export class MinAgeDobValidatorDirective implements Validator {
    @Input()
    minAgeDob: boolean;
  
  

  validate(control: AbstractControl): { [key: string]: any } {
        if (this.minAgeDob)
            return minAgeDobValidator()(control);
        return null;
    }
}

